import { Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { ME_Fit } from 'me-fit-typings';
import { AlgoliaSdkType, AlgoliaService } from 'src/app/services/algolia.service';

@Injectable()
export class ExerciseRendererService {

  constructor(private $algolia: AlgoliaService) {}

  private memorisedExercises = new Map<string, ME_Fit.Exercise>();

  /**
   * Sometimes we are sure an exercise is present locally, and we want to get its name synchronously. In that case we will use this method.
   */
  getLocalExercise(id: string) {
    return this.memorisedExercises.get(id);
  }

  // This needs to be memoized to reduce service calls
  //
  async getExerciseName(id: string) {

    const exercise = await this.getExerciseById(id);

    const exerciseName = exercise ? exercise.name : '';

    return exerciseName;
  }

  async getExerciseById(id: string, algoliaSdkType: AlgoliaSdkType = 'global'): Promise<ME_Fit.Exercise|undefined> {

    if (isNil(id)) {
      console.log(`[exercise-cell-renderer-service] id was null, returning nothing.`);
      return;
    }

    if (this.memorisedExercises.has(id)) {
      console.log(`[exercise-cell-renderer-service] already fetched exercise with ${id} before, returning cached version`);
      return this.memorisedExercises.get(id);
    }

    try {
      const exerciseObject = await this.$algolia.getObject<ME_Fit.Exercise>(id, algoliaSdkType);

      this.memorisedExercises.set(id, exerciseObject);

      return exerciseObject;
    } catch (error) {
      console.error(`[exercise-cell-renderer-service] error getting algolia object by id ${id}`, error);
    }

  }
}
